import { withInstall } from '../../../utils/with-install'
import MouseTool from './MouseTool.vue'

export const ElAmapMouseTool = withInstall(MouseTool)
export default ElAmapMouseTool
